



















import { getRgCategoryList } from '@/api/cti';
import { Vue, Component, Prop, Model, Emit, Watch } from 'vue-property-decorator';

@Component
export default class CategoryFilter extends Vue {
    @Model('change', { type: Array, default: () => [] })
    readonly value!: any[];

    rgItemList: {
        originalItem: any;
        itemId: number;
        fullName: string;
    }[] = [];

    internalValue: number[] = [];

    async created() {
        this.internalValue = this.getSelectedItemIds();
        await this._initRgAvailableItems();
    }

    @Watch('value')
    onValueChange(newVal: any[]) {
        this.internalValue = this.getSelectedItemIds();
    }

    @Emit('change')
    handleChange(value: number[]) {
        const selectedItems = this.rgItemList.filter(item => value.includes(item.itemId)).map(item => item.originalItem);
        console.log('selectedItems', selectedItems);
        return selectedItems;
    }

    getSelectedItemIds(): number[] {
        if (!this.value || this.value.length === 0) {
            return [];
        }
        return this.value.map(item => {
            if (typeof item === 'object' && item.itemId) {
                return item.itemId;
            }
            return item;
        });
    }

    private async _initRgAvailableItems() {
        try {
            const { data, code } = await getRgCategoryList({ sceneId: 9, keyword: '', rgId: this.rgId });
            if (code === 200) {
                this.rgItemList = data.items.map((item: any) => ({
                    itemId: item.itemId,
                    fullName: `${item.categoryName} / ${item.typeName} / ${item.itemName}`,
                    originalItem: item
                }));
            }
        } catch (_) {}
    }

    async getRgItemList(query: string) {
        try {
            const { data, code } = await getRgCategoryList({ sceneId: 9, keyword: query, rgId: this.rgId });
            if (code === 200) {
                this.rgItemList = data.items.map((item: any) => ({
                    itemId: item.itemId,
                    fullName: `${item.categoryName} / ${item.typeName} / ${item.itemName}`,
                    originalItem: item
                }));
                console.log('this.rgItemList', this.rgItemList);
            }
        } catch (_) {}
    }

    get rgId() {
        return parseInt(this.$route.query.rgId as string, 10);
    }
}
